import styled from 'styled-components';
import '../../styles/GlobalThemeStyle';
import PinInput from 'react-pin-input';

export const XPinInput = styled(PinInput)`
	.pincode-input-text {
		min-width: 100px !important;
	}
`;
export const XPara1 = styled.div`
	color: ${({ theme }) => theme.colors.themeColor4};
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;
	span {
		font-weight: 500;
	}
	a {
		color: ${({ theme }) => theme.colors.menu2};
		text-decoration: none;
		font-weight: 500;
	}
	@media only screen and (max-width: 769px) {
		font-size: 14px;
	}
`;
